import React, { useEffect }from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import PortfolioList from 'components/Agile/portfolio/portfolioList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import PortfolioAdd from 'components/Agile/portfolio/portfolioMaintenance/portfolioAdd';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';
import {
    fetchPortfolios,
    getAllPortfolio,
    getUnselectedAllPortfolio,
    handlePortfolioRequestClose,
    showPortfolioLoader,
    onAddPortfolio,
    onFilterSelectedPortfolio,
    onFilterPortfolioOptionSelect,
    onTogglePortfolioDrawer,
    updateSearchPortfolio,
    filterPortfolio,
} from 'actions/portfolio';

const filterOptions = [
    {
        id: 1,
        name: 'All portfolios',
        icon: 'zmdi-menu'
    }, {

        id: 2,
        name: 'Starred portfolios',
        icon: 'zmdi-star'
    }
];

const Component = () => {
    const dispatch = useDispatch();
    const width = useSelector(state => state.settings.width);

    const loader = useSelector(state => state.portfolios.loader);
    const alertMessage = useSelector(state => state.portfolios.alertMessage);
    const showMessage = useSelector(state => state.portfolios.showMessage);
    const noContentFoundMessage = useSelector(state => state.portfolios.noContentFoundMessage);
    const drawerState = useSelector(state => state.portfolios.drawerState);
    const portfolio = useSelector(state => state.portfolios.portfolio);
    const searchPortfolio = useSelector(state => state.portfolios.searchPortfolio);
    const portfolioList = useSelector(state => state.portfolios.portfolioList);
    const selectedPortfolios = useSelector(state => state.portfolios.selectedPortfolios);
    const addPortfolioState = useSelector(state => state.portfolios.addPortfolioState);
    const selectedSectionId = useSelector(state => state.portfolios.selectedSectionId);

    useEffect(() => {
        dispatch(showPortfolioLoader());
        dispatch(fetchPortfolios());
    }, []);

    const onAllPortfolioSelect = () => {
        const selectAll = selectedPortfolios < portfolioList.length;
        if (selectAll) {
            dispatch(getAllPortfolio());
        } else {
            dispatch(getUnselectedAllPortfolio());
        }
    };

    const updatingSearchPortfolio = (evt) => {
        dispatch(updateSearchPortfolio(evt.target.value));
        dispatch(filterPortfolio(evt.target.value));
    };

    const portfolioRequestClose = () => {
        dispatch(handlePortfolioRequestClose());
    };

    const portfolioSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.portfolios" /></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button id="addPortfolioButton" className="btn-block jr-btn" color="primary"
                            onClick={() => dispatch(onAddPortfolio())}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span><IntlMessages id="portfolio.addPortfolio" /></span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === selectedSectionId ? 'active' : ''} 
                                    onClick={() => dispatch(onFilterPortfolioOptionSelect(option))}>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    return (
        <div className="app-wrapper">
            <div className="app-module animated slideInUpTiny animation-duration-3">
                <div className="d-block d-xl-none">
                    <Drawer
                        touch={true}
                        transitions={true}
                        enableDragHandle={true}
                        open={drawerState}
                        onOpenChange={() => dispatch(onTogglePortfolioDrawer())}
                        sidebar={portfolioSideBar(portfolio)} />
                </div>
                <div className="app-module-sidenav d-none d-xl-flex">
                    {portfolioSideBar(portfolio)}
                </div>
                <div className="module-box">
                    <div className="module-box-header">
                        <span className="icon-btn drawer-btn d-flex d-xl-none"
                            onClick={() => dispatch(onTogglePortfolioDrawer())}>
                            <i className="zmdi zmdi-menu" />
                        </span>
                        <AppModuleHeader
                            placeholder="Search portfolio"
                            notification={false}
                            apps={false}
                            user={portfolio}
                            onChange={(event) => updatingSearchPortfolio(event)}
                            value={searchPortfolio} />
                    </div>
                    <div className="module-box-content">
                        <div className="module-box-topbar">
                            <div className="form-control-checkbox d-flex">
                                <div className="form-checkbox">
                                    <input type="checkbox"
                                        checked={selectedPortfolios > 0}
                                        onChange={onAllPortfolioSelect} />
                                    <span className="check">
                                        <i className="zmdi zmdi-check zmdi-hc-lg" />
                                    </span>
                                </div>
                            </div>
                            <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                onClick={() => dispatch(onFilterSelectedPortfolio())} >
                                <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                <span><IntlMessages id="label.filter.selected" /></span>
                            </Button>
                        </div>
                        <CustomScrollbars className="module-list-scroll scrollbar"
                            style={{ height: width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                            {loader ?
                                <div
                                    className="loader-view-block h-100">
                                    <div className="loader-view">
                                        <CircularProgress />
                                    </div>
                                </div>
                                :
                                portfolioList && portfolioList.length > 0 ?
                                    <PortfolioList />
                                    :
                                    <div className="h-100 d-flex align-items-center justify-content-center">
                                        {noContentFoundMessage}
                                    </div>
                            }
                        </CustomScrollbars>
                    </div>
                </div>
            </div>
            <PortfolioAdd
                open={addPortfolioState}
            />
            {showMessage && NotificationManager.success(alertMessage, portfolioRequestClose())}
            <NotificationContainer />
        </div>
    );
};

export default Component;



// WEBPACK FOOTER //
// ./components/Agile/portfolio/component.js